/**
 * @file 赎回确认弹窗
 */
import { useEffect } from 'react';
import { Button } from '@bfe/moly';
import { useFm } from '@web3/base-hooks';
import { Row, SlippageLostRow } from '@/components';
import { UnstakeContent } from '../unstakeContent';
import { UnstakeCoinInfoStore, GasStore } from '@/types/unstake';
import { formatUSDYield } from '@/utils/num';
import { scTrack } from '@web3/base-tracking';
import { Event } from '@/config/track-config';
import cls from 'classnames';
import { DelayRedeemInfo } from '@/types/unstake';
import { ShowType } from '@/types/account';
import {
  DelayPeriod,
  DelayRedeemNotify,
} from '@/containers/operation/account/unstakeInfo/components';
import styles from './index.module.scss';

interface Props {
  unstakeAmount: string;
  slippage: string;
  gasStore: GasStore;
  buttonIsLoading: boolean;
  confirmButtonText: string;
  selectCoinList: string[];
  slippageIsLost: boolean;
  unstakeCoinAmountStore: UnstakeCoinInfoStore;
  delayRedeemInfo: DelayRedeemInfo;
  showType: ShowType;
  beginUnstake: () => Promise<void>;
}

export const ConfirmModal = (props: Props) => {
  const {
    unstakeAmount,
    slippage,
    gasStore,
    buttonIsLoading,
    confirmButtonText,
    selectCoinList,
    slippageIsLost,
    unstakeCoinAmountStore,
    showType,
    delayRedeemInfo,
    beginUnstake,
  } = props;
  const fm = useFm();

  useEffect(() => {
    scTrack(Event.Web3PageView, {
      page_name: 'StakingWeb_bbSOLPageredeemdetail',
    });
  }, []);

  return (
    <>
      <div className={styles.content}>
        <UnstakeContent
          unstakeAmount={unstakeAmount}
          selectCoinList={selectCoinList}
          unstakeCoinAmountStore={unstakeCoinAmountStore}
        />
      </div>
      <DelayPeriod
        show={showType === ShowType.ConfimDelayUnStake}
        delayRedeemInfo={delayRedeemInfo}
      />
      <SlippageLostRow
        show={!!slippage}
        slippage={slippage}
        isWarn={slippageIsLost}
      />
      <Row
        label={fm('estimated_cost')}
        className={cls('mt-3', styles.cost)}
        value={
          <div>
            <div
              className={styles.amount}
            >{`${gasStore.amount} ${gasStore.symbol}`}</div>
            <div className={styles.price}>
              {`${formatUSDYield(gasStore.price)}`}
            </div>
          </div>
        }
      />
      <div className={styles.confirmBtnContainer}>
        <DelayRedeemNotify showType={showType} />
        <Button
          loading={buttonIsLoading}
          onClick={() => {
            scTrack(Event.Web3UserClick, {
              page_name: 'StakingWeb_bbSOLPageredeemdetail',
              button_name:
                showType === ShowType.ConfimDelayUnStake
                  ? 'redeem_detail_Delayed'
                  : 'redeem_detail_confirm',
            });
            beginUnstake();
          }}
          variant="primary"
          className={styles.button}
        >
          {showType === ShowType.ConfimDelayUnStake
            ? fm('confirmDelayRedem')
            : confirmButtonText}
        </Button>
      </div>
    </>
  );
};
